<div *ngIf="pageData$ | async as pageData" >
    <div class="VSCategorySlot1" *ngIf='pageData.products.length>0'>
        <div class="row" >
            <div class="col-8">
                <div class="category-name">{{ pageData?.currentQuery?.categoryName }}</div>
                <div class="category-description" [innerHTML]="pageData?.currentQuery?.categoryDescription">
                </div>
            </div>
            <div class="col-4">
                <img *ngIf="pageData?.currentQuery?.categoryPictureUrl" 
                    src="{{ apiurl + pageData?.currentQuery?.categoryPictureUrl }}" class="display-image"
                    alt="pageData.currentQuery.categoryName">
                <cx-media class="category-missing-img" *ngIf="!pageData?.currentQuery?.categoryPictureUrl"
                    [container]="apiurl+pageData?.currentQuery?.categoryPictureUrl">
                </cx-media>
            </div>
        </div>
    </div>
    
</div>
